import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-limestone',
  templateUrl: './limestone.component.html',
  styleUrls: ['./limestone.component.css']
})
export class LimestoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
